import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import Button from "components/Button";
import Loading from "components/Loading";
import Modal from "components/Modal";
import Title from "components/Title";
import CardLayout from "components/form/CardLayout";
import FormLayout from "components/form/FormLayout";
import TwoSideLayout from "components/form/TwoSideLayout";
import GalleryInputMulti from "components/gallery/GalleryInputMulti";
import GalleryModal from "components/gallery/GalleryModal";
import FieldWithTranslation from "components/inputs/FieldWithTranslation";
import TextInput from "components/inputs/TextInput";
import apiEndpoints from "configs/apiEndPoints";
import { FC, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import toastFunc from "utils/toast";
import { transformFieldWithTranslationForServer, transformFieldWithTranslationFromServer } from "utils/transformerFunctions";
import { useMutationCustom, useQueryCustom } from "utils/useQueryCUstom";
import { CONFIGS } from "../configs";
import { fieldNames, validation } from "./validation";
import SelectInput from "components/inputs/SelectInput";
import SelectInputAsync from "components/inputs/SlectInputAsync";

interface FormValues {
  title: {
    value: string;
    language: {
      value?: string;
      label?: string;
    };
  }[];
  description: {
    value: string;
    language: {
      value?: string;
      label?: string;
    };
  }[];
  listOrderNumber: number;
}

const Add: FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const URL_ID = id ? id : "";
  const { t } = useTranslation();
  const [editInitialLoading, setEditInitialLoading] = useState(id ? true : false);
  const [showGalleryModal, setShowGalleryModal] = useState(false);
  const [images, setImages] = useState<string[]>([]);

  const methods = useForm<FormValues>({
    resolver: yupResolver(validation(URL_ID, t)),
  });

  const updateOrCreate = URL_ID ? (params: any) => axios.put(apiEndpoints[CONFIGS.apiName].base + "/" + URL_ID, params) : (params: any) => axios.post(apiEndpoints[CONFIGS.apiName].base, params);

  // Get language data for transforming translation fields
  const { data: languageData, isLoading: languageIsLoading } = useQueryCustom({
    name: `${CONFIGS.title}_languages`,
    url: () => axios.get(apiEndpoints.languages.base),
    enabled: !!URL_ID,
  });

  // Get data by id in edit mode
  const onSuccessDataById = ({ data }: any) => {
    const item = { ...data?.data };
    const transformedTitle = transformFieldWithTranslationFromServer(item?.title, languageData.data.data.result, fieldNames.title);
    console.log("🚀 ~ onSuccessDataById ~ item:", item);
    const transformedDesc = transformFieldWithTranslationFromServer(item?.description, languageData.data.data.result, fieldNames.description);
    const transformedCategoryIds = item.categories.map((item: any) => ({
      label: item.title?.en,
      value: item._id,
    }));

    // handleSelectHomeImagesThumbnail(item?.images);
    methods.reset({
      ...item,
      ...transformedTitle,
      ...transformedDesc,
      categoryIds: transformedCategoryIds || [],
    });

    setEditInitialLoading(false);
  };

  const { data: dataById } = useQueryCustom({
    name: `${CONFIGS.title}_getById`,
    url: () => axios.get(apiEndpoints[CONFIGS.apiName].base + "/" + URL_ID),
    onSuccess: onSuccessDataById,
    enabled: !!URL_ID && !languageIsLoading,
  });

  const { isLoading, mutate: submitData } = useMutationCustom({
    url: updateOrCreate,
    invalidQuery: `${CONFIGS.title}_get`,
    onSuccess: () => {
      toastFunc.success({ title: "Success" });
      navigate(CONFIGS.routes.base);
    },
  });

  const onSubmit = (data: FormValues) => {
    const transformedTitle = transformFieldWithTranslationForServer(data.title, fieldNames.title);
    const transformedDescription = transformFieldWithTranslationForServer(data.description, fieldNames.description);

    const finalData = {

      listOrderNumber: data.listOrderNumber,

      ...transformedTitle,
      ...transformedDescription,
    };
    // console.log("🚀 Final data to submit:", finalData);
    submitData(finalData);
  };

  //-------------------------------- homeImages ----------------------------------
  const [showHomeImagesModal, setShowHomeImagesModal] = useState(false);
  const [homeImagesThumbnail, setHomeImagesThumbnail] = useState<any[] | string | null>([]);

  const handleHomeImagesModal = () => {
    setShowHomeImagesModal(!showHomeImagesModal);
  };

  // const handleSelectHomeImagesThumbnail = (thumbnail: any[] | string) => {
  //   setHomeImagesThumbnail(thumbnail);
  //   methods.setValue(fieldNames.images, thumbnail);
  //   methods.clearErrors(fieldNames.images);
  // };

  return (
    <div>
      {editInitialLoading && (
        <Modal isOpen title={t("loadingData")}>
          <div className="flex justify-center items-center">
            <Loading size="w-8 h-8" />
          </div>
        </Modal>
      )}

      <Title
        hasBtn
        btnTitle={t("backTitle", { changeablePart: t(CONFIGS.title) })}
        title={URL_ID ? t("editTitle", { changeablePart: t(CONFIGS.title) }) : t("addNew", { changeablePart: t(CONFIGS.title) })}
        url={CONFIGS.routes.base + CONFIGS.routes.list}
      />

      <FormProvider {...methods}>
        <form
          onSubmit={(e) => {
            // console.log("🟠 Submit clicked");
            methods.handleSubmit(onSubmit)(e);
          }}
          className="space-y-4"
        >
          <FormLayout
            main={
              <>
              
                <CardLayout>
                   <TextInput type="number" name={fieldNames.listOrderNumber} label={fieldNames.listOrderNumber} size="full" />
                  <FieldWithTranslation name={fieldNames.title} />
                  <FieldWithTranslation name={fieldNames.description} isDescription />
                </CardLayout>
              </>
            }
            side={
              <CardLayout head={{ title: "action" }} className="sticky top-4">
                <Button type="submit" variant="success" isFullSize loading={isLoading}>
                  {t("submit")}
                </Button>
              </CardLayout>
            }
          />
        </form>
      </FormProvider>

      
    </div>
  );
};

export default Add;
